<template>
    <div :class="classes">
        <slot/>
    </div>
</template>

<script>
export default {
    name: 'ur-section-column',
    props: {
        // $ver: v1.2.2
        // column 이 차지하는 영역에 대한 옵션
        // # Option for the area occupied by column
        possession: {
            type: String,
            required: true,
            validator (value) {
                return value  === 'all' ||
                    /^[1-9]$/.test(value) ||  /^[1][0-2]$/.test(value) // 1~12
            }
        }
    },
    computed: {
        classes () {
            let result = [];
            if (this.possession === 'all' || /^[1-9]$/.test(this.possession) ||  /^[1][0-2]$/.test(this.possession)) {
                result.push('ur-section__col--' + this.possession)
            }
            return result
        }
    }
}
</script>